<script>
import Layout from '@layouts/auth'
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import { ErrorWrapper } from '@utils/error-handler'
export default {
  page: {
    title: 'Reset Password',
    meta: [
      { name: 'description', content: `Reset Password to ${appConfig.title}` },
    ],
  },
  components: { Layout },
  data() {
    return {
      password: '',
      password1: '',
      error: null,
      tryingToReset: false,
      isResetError: false,
      isSuccess: false,
      successMessage: null,
      confirmPassword: false,
      validPassword: false,
    }
  },
  computed: {},
  mounted() {},
  methods: {
    ...authMethods,
    // Try to register the user in with the email, fullname
    // and password they provided.
    tryToReset() {
      this.tryingToReset = true
      // Reset the authError if it existed.
      this.error = null
      if (
        this.password.match(
          '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^]).{8,}'
        )
      ) {
        this.validPassword = false
        if (this.password === this.password1) {
          let Data = {
            id: this.$route.params.id,
            password: this.password,
          }

          this.resetPassword({
            Data,
          })
            .then((data) => {
              this.tryingToReset = false
              this.isResetError = false
              this.isSuccess = true
              this.successMessage = data.msg
              this.confirmPassword = false
              this.$bvToast.toast('Password Changed Successfully', {
                title: `Success`,
                toaster: 'b-toaster-top-right',
                solid: true,
                variant: 'success',
                appendToast: false,
              })
              setTimeout(() => {
                this.$router.push({
                  path: `/login`,
                })
              }, 3000)
            })
            .catch((error) => {
              this.tryingToReset = false
              var getError = new ErrorWrapper(error)
              this.error = getError.message
              this.isResetError = true
              this.isSuccess = false
            })
        } else {
          this.confirmPassword = true
        }
      } else {
        this.validPassword = true
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="text-center">
          <a href="/">
            <span>
              <img src="@assets/images/logo.png" alt="mindZcloud" height="80" />
            </span>
          </a>
          <p class="text-muted mt-2 mb-4">Admin Dashboard</p>
        </div>

        <div class="card">
          <div class="card-body p-4">
            <div class="text-center mb-4">
              <h4 class="text-uppercase mt-0 mb-3">Reset Password</h4>
              <p class="text-muted mb-0 font-13">
                Your password has to be atleast 8 characters long. It must
                contain one upper case letter, one lower case letter, one
                integer and one special character.</p
              >
            </div>

            <b-alert
              v-model="isResetError"
              variant="danger"
              v-html="error"
            ></b-alert>

            <b-alert
              v-model="isSuccess"
              variant="success"
              v-html="successMessage"
            ></b-alert>

            <b-form @submit.prevent="tryToReset">
              <b-form-group
                id="email-group"
                label="New Password"
                label-for="email"
              >
                <b-form-input
                  id="password"
                  v-model="password"
                  type="password"
                  required
                  placeholder="Enter new Password"
                ></b-form-input>
              </b-form-group>
              <p v-if="validPassword" style="color:red;">Add valid password</p>
              <b-form-group
                id="email-group"
                label="Confirm New Password"
                label-for="email"
              >
                <b-form-input
                  id="password1"
                  v-model="password1"
                  type="password"
                  required
                  placeholder="Confirm Password"
                ></b-form-input>

                <p v-if="confirmPassword" style="color:red;"
                  >Password not matched</p
                >
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Reset Password</b-button
                >
              </b-form-group>
            </b-form>
          </div>
          <div class="col-12 text-center">
            <p class="text-muted">
              Already have account?
              <router-link tag="a" to="/login" class="text-dark ml-1">
                <b>Log In</b>
              </router-link>
            </p>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
